export const MESSAGE_TEMPLATE_DELETE_OPEN_MODAL = "MESSAGE_TEMPLATE_DELETE_OPEN_MODAL";
export const MESSAGE_TEMPLATE_DELETE_REQUEST = "MESSAGE_TEMPLATE_DELETE_REQUEST";
export const MESSAGE_TEMPLATE_DELETE_RESULT = "MESSAGE_TEMPLATE_DELETE_RESULT";